module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "img_dialog",
    attrs: {
      "title": "选择图片",
      "visible": _vm.showDialog,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "before-close": _vm.cancelAction,
      "append-to-body": ""
    }
  }, [_c('div', {
    staticClass: "img_pick_panel inner_container_box"
  }, [_c('el-row', [_c('el-col', [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "本地上传",
      "name": "localimages"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "inner_main"
  }, [_c('div', {
    staticClass: "img_pick_area"
  }, [_c('div', {
    staticClass: "sub_title_bar in_dialog"
  }, [(_vm.filesystem == 'qiniu') ? _c('div', {
    staticClass: "upload_box"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "multiple": true,
      "action": _vm.actionPath,
      "accept": "image/jpeg,image/png,image/gif",
      "show-file-list": false,
      "data": _vm.localpostData,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("本地上传")])], 1)], 1) : _c('div', {
    staticClass: "upload_box"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "multiple": true,
      "http-request": _vm.httpRequest,
      "action": _vm.temporary_url,
      "accept": "image/jpeg,image/png,image/gif",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("本地上传")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "img_pick_area_inner"
  }, [_c('div', {
    staticClass: "img_pick"
  }, [_c('div', {
    staticClass: "img_list"
  }, _vm._l((_vm.localimgList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "img_item",
      on: {
        "click": function($event) {
          return _vm.localcheckedImg(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "frm_checkbox_label img_item_bd",
      class: _vm.isMost ? {
        selected: item.selected
      } : {
        'selected': _vm.locali == index
      }
    }, [_c('div', {
      staticClass: "pic_box"
    }, [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": item.image_full_url
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "lbl_content"
    }, [_vm._v(_vm._s(item.image_name))]), _vm._v(" "), _c('div', {
      staticClass: "selected_mask"
    }, [_c('div', {
      staticClass: "selected_mask_inner"
    }), _vm._v(" "), _c('div', {
      staticClass: "selected_mask_icon el-icon-check"
    })])])])
  }), 0)])])]), _vm._v(" "), (_vm.localimgData.total_count > _vm.localparams.pageSize) ? _c('div', {
    staticClass: "pager-wrap tc"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.localparams.page,
      "page-sizes": [_vm.localparams.pageSize],
      "total": _vm.localimgData.total_count,
      "page-size": _vm.localparams.pageSize
    },
    on: {
      "current-change": _vm.localhandleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.localparams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.localparams, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelAction
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.localsaveAction
    }
  }, [_vm._v("确 定")])], 1)])]), _vm._v(" "), (_vm.$store.getters.login_type != 'distributor') ? _c('el-tab-pane', {
    attrs: {
      "label": "微信上传",
      "name": "wechatimages"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "inner_main"
  }, [_c('div', {
    staticClass: "img_pick_area"
  }, [_c('div', {
    staticClass: "sub_title_bar in_dialog"
  }, [_c('div', {
    staticClass: "upload_box"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "",
      "auto-upload": false,
      "show-file-list": false,
      "on-change": _vm.uploadImage,
      "disabled": true,
      "multiple": true
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("微信上传(请选择本地上传)")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "img_pick_area_inner"
  }, [_c('div', {
    staticClass: "img_pick"
  }, [_c('div', {
    staticClass: "img_list"
  }, _vm._l((_vm.imgList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "img_item",
      on: {
        "click": function($event) {
          return _vm.checkedImg(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "frm_checkbox_label img_item_bd",
      class: _vm.isMost ? {
        selected: item.selected
      } : {
        'selected': _vm.i == index
      }
    }, [_c('div', {
      staticClass: "pic_box"
    }, [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": _vm.wximageurl + item.url
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "lbl_content"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "selected_mask"
    }, [_c('div', {
      staticClass: "selected_mask_inner"
    }), _vm._v(" "), _c('div', {
      staticClass: "selected_mask_icon el-icon-check"
    })])])])
  }), 0)])])]), _vm._v(" "), (_vm.imgData.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "pager-wrap tc"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [_vm.params.pageSize],
      "total": _vm.imgData.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelAction
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAction
    }
  }, [_vm._v("确 定")])], 1)])]) : _vm._e()], 1)], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-66e41228", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66e41228"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/imageselect/index.vue
// module id = 2789
// module chunks = 0